import cn from 'classnames';
import styles from './Stars.module.scss';
import { Icon } from '../../../Icon';

interface StarsProps {
  rating: number;
  className?: string;
}

export const Stars = ({ rating, className }: StarsProps) => {
  const normalizedRating = Math.max(0, Math.min(5, rating));
  const ratingFloor = Math.floor(normalizedRating);
  const decimals = normalizedRating - ratingFloor;
  const starTypes = Array.from({ length: ratingFloor }, () => 'star');

  if (decimals > 0.2 && decimals < 0.7) {
    starTypes.push('star-half');
  }

  if (decimals >= 0.7) {
    starTypes.push('star');
  }

  return (
    <div
      aria-label={`${normalizedRating} out of 5 stars`}
      className={cn(styles.root, className)}
    >
      {starTypes.map((type, index) => (
        <Icon
          key={`${type}-${index.toString()}`}
          classname={styles.icon}
          type={type as 'star' | 'star-half'}
          alt=""
        />
      ))}
    </div>
  );
};
